import { COVERS } from "@ui/tokens/classCover";
import { ColorChoice } from "./ColorChoice";

/**
 * The quick picks are the palette's own mid tones — the same eight colours the covers are built
 * from, so a teacher in a hurry lands on a colour the product already knows how to draw. The deep
 * and light ends of the gradient are derived from whichever colour comes out of here.
 */
const PRESETS: readonly string[] = COVERS.map((cover) => cover.b.toUpperCase());

interface ClassColorPickerProps {
  value: string;
  onChange: (hex: string) => void;
}

export const ClassColorPicker = ({ value, onChange }: ClassColorPickerProps) => (
  <ColorChoice colors={PRESETS} value={value} onChange={onChange} label="Couleur de la classe" />
);
